import React from 'react';
import { Grid } from '@mui/material';

import PieChart from './PieChart';
import TrendChart from './TrendChart';

const ChartsView: React.FC = () => {
  return (
    <div className="charts-view-container">
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <PieChart />
        </Grid>
        <Grid item xs={7}>
          <TrendChart />
        </Grid>
      </Grid>
    </div>
  );
};

export default ChartsView;
